<template>
  <v-main class="redeem-code-detail-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>兑换码</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!isCreate" color="red" class="ml-4" outlined small @click="onDelete">删除</v-btn>
    </v-app-bar>
    <v-container class="form" fluid>
      <v-textarea
        label="兑换码"
        hint="默认为随机值，可任意修改。支持批量创建，一行一个码。"
        class="required"
        v-model="form.value"
        :readonly="!isCreate"
        :rows="1"
        auto-grow
      ></v-textarea>
      <v-select
        :readonly="!isCreate"
        label="兑换商品"
        class="required"
        v-model="form.product_id"
        :items="product_option_s"
      ></v-select>
      <v-text-field label="兑换码总量" class="required" v-model="form.total_count" type="number"></v-text-field>
      <v-text-field label="兑换码有效期" class="required" v-model="form.dt_expiration"></v-text-field>
      <v-text-field label="推广员" v-model="form.promoter" type="text"></v-text-field>
      <v-checkbox label="启用" v-model="form.is_enable"></v-checkbox>
      <v-btn width="100%" color="primary" class="mt-8" @click="onSave">保存</v-btn>
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { homeStore } from '@/store/home'
import { productStore } from '@/store/product'
import { redeemCodeStore } from '@/store/redeemCode'
import { mdiPlus } from '@mdi/js'
import _ from 'lodash'

function _parseDate(s) {
  return s ? new Date(s) : null
}

function randomCode(length) {
  var result = ''
  var characters = '0123456789ABCDEFGHKMNPQRSTUVWXYZ'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export default {
  name: 'RedeemCodeDetailPage',
  components: { AppbarBackIcon },
  data() {
    let now = new Date().getTime()
    let oneYear = 365 * 24 * 60 * 60 * 1000
    let dt_expiration = new Date(now + oneYear)
    dt_expiration.setMinutes(0, 0, 0)
    return {
      mdiPlus,
      form: {
        value: randomCode(12),
        product_id: null,
        total_count: 1,
        dt_expiration: dt_expiration.toISOString(),
        is_enable: true,
        promoter: null,
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.id || null
    },
    isCreate() {
      return _.isNil(this.id)
    },
    redeemCode() {
      return redeemCodeStore.get(this.id)
    },
    product_option_s() {
      return productStore.list.map(product => {
        let redeem = product.is_redeem ? '可兑换' : '不可兑换'
        return {
          text: `${product.name} - ${redeem}`,
          value: product.id,
        }
      })
    },
  },
  async mounted() {
    await homeStore.doLoad()
    await productStore.doLoad()
    if (!this.isCreate && _.isNil(this.redeemCode)) {
      await redeemCodeStore.doQuery({
        id: this.id,
      })
    }
    if (!this.isCreate) {
      this.syncForm()
    }
  },
  methods: {
    syncForm() {
      this.form.dt_expiration = this.redeemCode.dt_expiration
      this.form.value = this.redeemCode.value
      this.form.product_id = this.redeemCode.product_id
      this.form.total_count = this.redeemCode.total_count
      this.form.promoter = this.redeemCode.promoter
      this.form.is_enable = this.redeemCode.is_enable
    },
    async onSave() {
      let dt_expiration = _parseDate(this.form.dt_expiration)
      let payload = {
        value: this.form.value,
        product_id: this.form.product_id,
        dt_expiration: dt_expiration,
        total_count: this.form.total_count,
        promoter: this.form.promoter,
        is_enable: this.form.is_enable,
      }
      if (this.isCreate) {
        let value_s = this.form.value.trim().split(/\s+/)
        let redeemCode = null
        for (let value of value_s) {
          payload.value = value
          redeemCode = await redeemCodeStore.doCreate(payload)
          this.$toasted.success(`${value}: 创建成功`)
        }
        this.$router.replace({ query: { id: redeemCode.id } })
        this.syncForm()
      } else {
        payload.id = this.id
        await redeemCodeStore.doUpdate(payload)
        this.$toasted.success('保存成功')
      }
    },
    async onDelete() {
      if (this.isCreate) {
        return
      }
      const msg = `确定要删除兑换码「${this.redeemCode.value}」吗`
      if (!(await this.$dialog.confirm({ text: msg }))) {
        return
      }
      await redeemCodeStore.doDelete(this.id)
      this.$toasted.success('删除成功')
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
.redeem-code-detail-page {
  .form {
    padding-bottom: 64px;
  }
}
</style>
